export default {
    state: {
        guestLinks: [
            {
                title: 'Login',
                link: { name: 'login' },
                icon: 'mdi-login'
            },
        ],
        loggedLinks: [
            {
                title: 'Dashboard',
                link: { name: 'dashboard' },
                icon: 'mdi-monitor-dashboard'
            },
            {
                title: 'Cash-flow',
                link: { name: 'cashflow' },
                icon: 'mdi-file-chart'
            },
            {
                title: 'Settings',
                link: { name: 'projects-dashboard' },
                icon: 'mdi-account-details'
            },
            {
                title: 'Financial Statement',
                icon: 'mdi-hand-coin-outline',
                expanded: false,
                children: [
                    {
                        title: 'Income Statement',
                        link: { name: 'income-statement' },
                        icon: 'mdi-align-vertical-bottom'
                    },
                    {
                        title: 'Balance Sheet',
                        link: { name: 'balance-sheet' },
                        icon: 'mdi-account-cash'
                    },
                ]
            },
        ],
    },
    mutations: {
        EXPAND_MENU(state, index) {
          state.loggedLinks[index].expanded = true;
        },
        REMOVE_EXPANSIONS(state) {
            state.loggedLinks.forEach((link, index) => {
                if (link.expanded !== undefined) {
                    state.loggedLinks[index].expanded = false;
                }
            })
        }
    },
    actions: {
        expandMenu({ commit }, index) {
          commit('REMOVE_EXPANSIONS');
          commit('EXPAND_MENU', index);
        },
        removeExpansions({ commit }) {
            commit('REMOVE_EXPANSIONS');
        }
    },
    getters: {
        links: (state, getters, rootAction, rootGetters) => {
            if (rootGetters.isAuthenticated) {
                return state.loggedLinks;
            }

            return state.guestLinks;
        },
    }
}